import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useUser } from 'store/userSlice';
import { handleWebClockLogout } from '../utils/webClockSession';

/**
 * Returns a stable logout handler that confirms offline cleanup before
 * signing out, or fail-closes when cleanup is unconfirmed.
 *
 * @returns {() => Promise<void>}
 */
export const useWebClockLogout = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useUser();

  return useCallback(() => {
    return handleWebClockLogout({ dispatch, history, user });
  }, [dispatch, history, user]);
};
